<bringoz-icon [iconName]="icon || 'BOX'" [ngbTooltip]="name ? name : null" openDelay="300" [fill]="iconFill"></bringoz-icon>
